export default "__VITE_ASSET__13f3245c__"